import * as styledComponents from "styled-components/native";
var styled = styledComponents.default, css = styledComponents.css, ThemeProvider = styledComponents.ThemeProvider;
//  as styledComponents.ReactNativeThemedStyledComponentsModule<
//   ITheme
// >;
export { css, ThemeProvider };
export default styled;
